export default __webpack_public_path__ + "static/media/LightingLeft.00ecdca0.png";